import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { WEB_TYPE } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { LINK_URL } from "infrastructure/config/CONSTANTS"

interface props {
    masterUseCase: MasterUseCaseInterface;
}

const CU02101Page = ({ masterUseCase }: props) => {
    const [webUrl, setWebUrl] = useState<string>('');

    useEffect(() => {
        getWebAppUrl(WEB_TYPE.CU_021_01);
    }, []);

    const getWebAppUrl = async (type: number) => {
        try {
            setWebUrl(LINK_URL.TERM_OF_SERVICE);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            console.log();
        }
    };

    return (
        <div className="CU-021-01-container">
            <section>
                <PageTitle title="利用規約" />
            </section>
            <section className="body">
                {webUrl ? (
                    <iframe src={webUrl} className="page content"></iframe>
                ) : (
                    <div className="page non-content">
                        <span>Webコンテンツが表示されます。</span>
                    </div>
                )}
            </section>
        </div>
    );
};

export default CU02101Page;
